"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildYearMonthChain = exports.yearMonthFns = void 0;
const ES = __importStar(require("../ecmascript"));
const durationFns_1 = require("./durationFns");
const dateFns_1 = require("./dateFns");
const format_1 = __importDefault(require("../format"));
const DISALLOWED_UNITS = ['week', 'day', 'hour', 'minute', 'second', 'millisecond'];
exports.yearMonthFns = {
    fromNumbers(year, month) {
        year = ES.ToIntegerThrowOnInfinity(year);
        month = ES.ToIntegerThrowOnInfinity(month);
        // Note: if the arguments are not passed,
        //       ToIntegerThrowOnInfinity(undefined) will have returned 0, which will
        //       be rejected by RejectISODate in CreateTemporalYearMonthSlots. This
        //       check exists only to improve the error message.
        if (arguments.length < 2) {
            throw new RangeError('missing argument: isoYear and isoMonth are required');
        }
        return ES.CreateTemporalYearMonth(year, month);
    },
    isValid(yearMonth) {
        return ES.IsTemporalYearMonth(yearMonth);
    },
    assertIsValid(yearMonth) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
    },
    getYear(yearMonth) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        return ES.CalendarYear(yearMonth);
    },
    getMonth(yearMonth) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        return ES.CalendarMonth(yearMonth);
    },
    getDaysInMonth(yearMonth) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        return ES.CalendarDaysInMonth(yearMonth);
    },
    getDaysInYear(yearMonth) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        return ES.CalendarDaysInYear(yearMonth);
    },
    inLeapYear(yearMonth) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        return ES.CalendarInLeapYear(yearMonth);
    },
    with(yearMonth, temporalYearMonthLike, options = undefined) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        if (typeof temporalYearMonthLike !== 'object') {
            throw new TypeError('invalid argument');
        }
        if (temporalYearMonthLike.timeZone !== undefined) {
            throw new TypeError('with() does not support a timeZone property');
        }
        const props = ES.ToPartialRecord(temporalYearMonthLike, ['month', 'year']);
        if (!props) {
            throw new TypeError('invalid year-month-like');
        }
        let fields = ES.ToTemporalYearMonthFields(ES.GetYearMonthSlots(yearMonth));
        fields = ES.CalendarMergeFields(fields, props);
        fields = ES.ToTemporalYearMonthFields(fields);
        options = ES.GetOptionsObject(options);
        return ES.YearMonthFromFields(fields, options);
    },
    add(yearMonth, temporalDurationLike, options = undefined) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        const duration = ES.ToLimitedTemporalDuration(temporalDurationLike);
        let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = duration;
        ({ days } = ES.BalanceDuration(days, hours, minutes, seconds, milliseconds, 'day'));
        options = ES.GetOptionsObject(options);
        const fields = ES.ToTemporalYearMonthFields(ES.GetYearMonthSlots(yearMonth));
        const sign = ES.DurationSign(years, months, weeks, days, 0, 0, 0, 0);
        const day = sign < 0 ? ES.ToPositiveInteger(ES.CalendarDaysInMonth(yearMonth)) : 1;
        const startDate = ES.DateFromFields(Object.assign(Object.assign({}, fields), { day }));
        const optionsCopy = Object.assign({}, options);
        const addedDate = ES.CalendarDateAdd(startDate, Object.assign(Object.assign({}, duration), { days }), options);
        const addedDateFields = ES.ToTemporalYearMonthFields(ES.GetDateSlots(addedDate));
        return ES.YearMonthFromFields(addedDateFields, optionsCopy);
    },
    subtract(yearMonth, temporalDurationLike, options = undefined) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        let duration = ES.ToLimitedTemporalDuration(temporalDurationLike);
        duration = {
            years: -duration.years,
            months: -duration.months,
            weeks: -duration.weeks,
            days: -duration.days,
            hours: -duration.hours,
            minutes: -duration.minutes,
            seconds: -duration.seconds,
            milliseconds: -duration.milliseconds
        };
        let { years, months, weeks, days, hours, minutes, seconds, milliseconds } = duration;
        ({ days } = ES.BalanceDuration(days, hours, minutes, seconds, milliseconds, 'day'));
        options = ES.GetOptionsObject(options);
        const fields = ES.ToTemporalYearMonthFields(ES.GetYearMonthSlots(yearMonth));
        const sign = ES.DurationSign(years, months, weeks, days, 0, 0, 0, 0);
        const day = sign < 0 ? ES.ToPositiveInteger(ES.CalendarDaysInMonth(yearMonth)) : 1;
        const startDate = ES.DateFromFields(Object.assign(Object.assign({}, fields), { day }));
        const optionsCopy = Object.assign({}, options);
        const addedDate = ES.CalendarDateAdd(startDate, Object.assign(Object.assign({}, duration), { days }), options);
        const addedDateFields = ES.ToTemporalYearMonthFields(ES.GetDateSlots(addedDate));
        return ES.YearMonthFromFields(addedDateFields, optionsCopy);
    },
    until(yearMonth, other, options = undefined) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        other = ES.ToTemporalYearMonth(other);
        options = ES.GetOptionsObject(options);
        const smallestUnit = ES.ToSmallestTemporalUnit(options, 'month', DISALLOWED_UNITS);
        const largestUnit = ES.ToLargestTemporalUnit(options, 'auto', DISALLOWED_UNITS, 'year');
        ES.ValidateTemporalUnitRange(largestUnit, smallestUnit);
        const roundingMode = ES.ToTemporalRoundingMode(options, 'trunc');
        const roundingIncrement = ES.ToTemporalRoundingIncrement(options, undefined, false);
        const otherFields = ES.ToTemporalYearMonthFields(ES.GetYearMonthSlots(other));
        const thisFields = ES.ToTemporalYearMonthFields(ES.GetYearMonthSlots(yearMonth));
        const otherDate = ES.DateFromFields(Object.assign(Object.assign({}, otherFields), { day: 1 }));
        const thisDate = ES.DateFromFields(Object.assign(Object.assign({}, thisFields), { day: 1 }));
        const untilOptions = Object.assign(Object.assign({}, options), { largestUnit });
        const result = ES.CalendarDateUntil(thisDate, otherDate, untilOptions);
        if (smallestUnit === 'month' && roundingIncrement === 1)
            return result;
        let { years, months } = ES.GetDurationSlots(result);
        const thisDateSlots = ES.GetDateSlots(thisDate);
        const relativeTo = ES.CreateTemporalDateTime(thisDateSlots.year, thisDateSlots.month, thisDateSlots.day, 0, 0, 0, 0);
        ({ years, months } = ES.RoundDuration(years, months, 0, 0, 0, 0, 0, 0, roundingIncrement, smallestUnit, roundingMode, relativeTo));
        return ES.CreateTemporalDuration(years, months, 0, 0, 0, 0, 0, 0);
    },
    since(yearMonth, other, options = undefined) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        other = ES.ToTemporalYearMonth(other);
        options = ES.GetOptionsObject(options);
        const smallestUnit = ES.ToSmallestTemporalUnit(options, 'month', DISALLOWED_UNITS);
        const largestUnit = ES.ToLargestTemporalUnit(options, 'auto', DISALLOWED_UNITS, 'year');
        ES.ValidateTemporalUnitRange(largestUnit, smallestUnit);
        const roundingMode = ES.ToTemporalRoundingMode(options, 'trunc');
        const roundingIncrement = ES.ToTemporalRoundingIncrement(options, undefined, false);
        const otherFields = ES.ToTemporalYearMonthFields(ES.GetYearMonthSlots(other));
        const thisFields = ES.ToTemporalYearMonthFields(ES.GetYearMonthSlots(yearMonth));
        const otherDate = ES.DateFromFields(Object.assign(Object.assign({}, otherFields), { day: 1 }));
        const thisDate = ES.DateFromFields(Object.assign(Object.assign({}, thisFields), { day: 1 }));
        const untilOptions = Object.assign(Object.assign({}, options), { largestUnit });
        let { years, months } = ES.GetDurationSlots(ES.CalendarDateUntil(thisDate, otherDate, untilOptions));
        if (smallestUnit === 'month' && roundingIncrement === 1) {
            return ES.CreateTemporalDuration(-years, -months, 0, 0, 0, 0, 0, 0);
        }
        const thisDateSlots = ES.GetDateSlots(thisDate);
        const relativeTo = ES.CreateTemporalDateTime(thisDateSlots.year, thisDateSlots.month, thisDateSlots.day, 0, 0, 0, 0);
        ({ years, months } = ES.RoundDuration(years, months, 0, 0, 0, 0, 0, 0, roundingIncrement, smallestUnit, ES.NegateTemporalRoundingMode(roundingMode), relativeTo));
        return ES.CreateTemporalDuration(-years, -months, 0, 0, 0, 0, 0, 0);
    },
    equals(yearMonth, other) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        other = ES.ToTemporalYearMonth(other);
        const slots1 = ES.GetYearMonthSlots(yearMonth);
        const slots2 = ES.GetYearMonthSlots(other);
        for (const slot of ['year', 'month']) {
            const val1 = slots1[slot];
            const val2 = slots2[slot];
            if (val1 !== val2)
                return false;
        }
        return true;
    },
    isEqual(yearMonth, other) {
        return exports.yearMonthFns.equals(yearMonth, other);
    },
    isBefore(yearMonth, other) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        other = ES.ToTemporalYearMonth(other);
        const slots1 = ES.GetYearMonthSlots(yearMonth);
        const slots2 = ES.GetYearMonthSlots(other);
        for (const slot of ['year', 'month']) {
            const val1 = slots1[slot];
            const val2 = slots2[slot];
            if (val1 < val2)
                return true;
            else if (val1 > val2)
                return false;
        }
        return false;
    },
    isAfter(yearMonth, other) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        other = ES.ToTemporalYearMonth(other);
        const slots1 = ES.GetYearMonthSlots(yearMonth);
        const slots2 = ES.GetYearMonthSlots(other);
        for (const slot of ['year', 'month']) {
            const val1 = slots1[slot];
            const val2 = slots2[slot];
            if (val1 > val2)
                return true;
            else if (val1 < val2)
                return false;
        }
        return false;
    },
    isEqualOrBefore(yearMonth, other) {
        return exports.yearMonthFns.isEqual(yearMonth, other) || exports.yearMonthFns.isBefore(yearMonth, other);
    },
    isEqualOrAfter(yearMonth, other) {
        return exports.yearMonthFns.isEqual(yearMonth, other) || exports.yearMonthFns.isAfter(yearMonth, other);
    },
    toDate(yearMonth, day) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        if (typeof day !== 'number')
            throw new TypeError('argument should be a number');
        return ES.DateFromFields(Object.assign(Object.assign({}, ES.GetYearMonthSlots(yearMonth)), { day }), { overflow: 'reject' });
    },
    getFields(yearMonth) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        return ES.GetYearMonthSlots(yearMonth);
    },
    from(item, options = undefined) {
        options = ES.GetOptionsObject(options);
        if (ES.IsTemporalYearMonth(item)) {
            ES.ToTemporalOverflow(options); // validate and ignore
            const slots = ES.GetYearMonthSlots(item);
            return ES.CreateTemporalYearMonth(slots.year, slots.month);
        }
        return ES.ToTemporalYearMonth(item, options);
    },
    compare(one, two) {
        one = ES.ToTemporalYearMonth(one);
        two = ES.ToTemporalYearMonth(two);
        const slots1 = ES.GetYearMonthSlots(one);
        const slots2 = ES.GetYearMonthSlots(two);
        return ES.CompareISODate(slots1.year, slots1.month, 1, slots2.year, slots2.month, 1);
    },
    format(yearMonth, formatString) {
        if (!ES.IsTemporalYearMonth(yearMonth))
            throw new TypeError('invalid receiver');
        return format_1.default(ES.GetYearMonthSlots(yearMonth), formatString);
    },
    chain: buildYearMonthChain
};
function buildYearMonthChain(yearMonth) {
    return {
        value() {
            return yearMonth;
        },
        getYear() {
            return ES.buildChain(exports.yearMonthFns.getYear(yearMonth));
        },
        getMonth() {
            return ES.buildChain(exports.yearMonthFns.getMonth(yearMonth));
        },
        getDaysInMonth() {
            return ES.buildChain(exports.yearMonthFns.getDaysInMonth(yearMonth));
        },
        getDaysInYear() {
            return ES.buildChain(exports.yearMonthFns.getDaysInYear(yearMonth));
        },
        inLeapYear() {
            return ES.buildChain(exports.yearMonthFns.inLeapYear(yearMonth));
        },
        with(yearMonthLike, options) {
            return buildYearMonthChain(exports.yearMonthFns.with(yearMonth, yearMonthLike, options));
        },
        add(temporalDurationLike, options) {
            return buildYearMonthChain(exports.yearMonthFns.add(yearMonth, temporalDurationLike, options));
        },
        subtract(temporalDurationLike, options) {
            return buildYearMonthChain(exports.yearMonthFns.subtract(yearMonth, temporalDurationLike, options));
        },
        until(other, options) {
            return durationFns_1.buildDurationChain(exports.yearMonthFns.until(yearMonth, other, options));
        },
        since(other, options) {
            return durationFns_1.buildDurationChain(exports.yearMonthFns.since(yearMonth, other, options));
        },
        equals(other) {
            return ES.buildChain(exports.yearMonthFns.equals(yearMonth, other));
        },
        isEqual(other) {
            return ES.buildChain(exports.yearMonthFns.isEqual(yearMonth, other));
        },
        isBefore(other) {
            return ES.buildChain(exports.yearMonthFns.isBefore(yearMonth, other));
        },
        isAfter(other) {
            return ES.buildChain(exports.yearMonthFns.isAfter(yearMonth, other));
        },
        isEqualOrBefore(other) {
            return ES.buildChain(exports.yearMonthFns.isEqualOrBefore(yearMonth, other));
        },
        isEqualOrAfter(other) {
            return ES.buildChain(exports.yearMonthFns.isEqualOrAfter(yearMonth, other));
        },
        toDate(day) {
            return dateFns_1.buildDateChain(exports.yearMonthFns.toDate(yearMonth, day));
        },
        getFields() {
            return ES.buildChain(exports.yearMonthFns.getFields(yearMonth));
        },
        format(formatString) {
            return ES.buildChain(exports.yearMonthFns.format(yearMonth, formatString));
        }
    };
}
exports.buildYearMonthChain = buildYearMonthChain;
